

























import Vue from 'vue';
import { IPartnerShopInformation } from '@/common/interfaces/partnershop.interface';
import ProfileAvatar from '@/components/common/profile-avatar/ProfileAvatar.vue';
import PartnerShopMethods from '../../methods/PartnerShopMethods';
import config from '../../../config';

interface IPartnerMap {
  googleMapApiKey: string;
  googleMapUrl: string;
  partnerShopInformation: IPartnerShopInformation;
  partnerShopName: string;
}

export default Vue.extend({
  name: `PartnerMap`,
  components: {
    ProfileAvatar,
  },
  data(): IPartnerMap {
    return {
      googleMapApiKey: config.googleMap.apiKey,
      googleMapUrl: ``,
      partnerShopInformation: {},
      partnerShopName: window.location.hostname.split(`.`)[0],
    };
  },
  computed: {
    displayFullName(): string {
      if(this.partnerShopInformation) {
        if(this.partnerShopInformation.firstname && this.partnerShopInformation.lastname) {
          return `${this.partnerShopInformation.firstname} ${this.partnerShopInformation.lastname}`;
        }
        if(this.partnerShopInformation.company) {
          return this.partnerShopInformation.company;
        }
      }
      return ``;
    },
    formatAddress(): string {
      let address = ``;
      if(this.partnerShopInformation.address) {
        address += this.partnerShopInformation.address.street ? `${this.partnerShopInformation.address.street} ` : ``;
        address += this.partnerShopInformation.address.streetNumber ? this.partnerShopInformation.address.streetNumber : ``;

        address += (this.partnerShopInformation.address.street && this.partnerShopInformation.address.streetNumber) ? `, ` : ``;

        address += this.partnerShopInformation.address.postalCode ? `${this.partnerShopInformation.address.postalCode} ` : ``;
        address += this.partnerShopInformation.address.city ? this.partnerShopInformation.address.city : ``;

        address += (this.partnerShopInformation.address.postalCode && this.partnerShopInformation.address.city) ? `, ` : ``;

        address += this.partnerShopInformation.address.country ? this.partnerShopInformation.address.country : ``;
      }
      return address;
    },
  },
  async mounted(): Promise<void> {
    await this.fetchPartnerShopInformation();
    window.$swal = this.$swal;
  },
  methods: {
    async fetchPartnerShopInformation(): Promise<void> {
      this.partnerShopInformation = await PartnerShopMethods.getPartnerShopInformation();

      if(this.partnerShopInformation && this.partnerShopInformation.address) {
        if(this.partnerShopInformation.address.latitude && this.partnerShopInformation.address.longitude) {
          this.googleMapUrl = `${config.googleMap.embedUrl}${this.partnerShopInformation.address.latitude},
          ${this.partnerShopInformation.address.longitude}${this.googleMapApiKey}`;
        } else {
          const { address } = this.partnerShopInformation;
          const mapParams = [];
          if(address.country) mapParams.push(encodeURIComponent(address.country));
          if(address.postalCode && address.city) mapParams.push(`${encodeURIComponent(address.postalCode)}+${encodeURIComponent(address.city)}`);
          else if(address.postalCode) mapParams.push(encodeURIComponent(address.postalCode));
          else if(address.city) mapParams.push(encodeURIComponent(address.city));
          if(address.street && address.streetNumber) mapParams.push(`${encodeURIComponent(address.street)}+${encodeURIComponent(address.streetNumber)}`);
          else if(address.street) mapParams.push(encodeURIComponent(address.street));
          else if(address.streetNumber) mapParams.push(encodeURIComponent(address.streetNumber));

          const mapParamsString = mapParams.length ? mapParams.join(`,`) : null;
          // postalCode+city,street+streetnumber,country
          if(mapParamsString) this.googleMapUrl = `${config.googleMap.embedUrl}${mapParamsString}${this.googleMapApiKey}`;
        }
      }
    },
  },
});
